import React from "react";
import ReactTable from "react-table";
import { Link } from 'react-router-dom';
import '../../../stylesheets/shared/react-table.css';
import moment from 'moment-timezone';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { voteActionCreators } from '../../../stores/lis-votes-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { cancelRequest } from '../../../services/request.service';
import { authActionCreators } from "../../../stores/lis-auth-store";

const customStyles = {
    option: (base, state) => ({
        ...base,
        fontSize: '0.8em',
    }),
    control: (base) => ({
        ...base,
        padding: '1px',
        margin: 0,
        minHeight: 0,
        fontSize: '0.8em',
    }),
    singleValue: (base, state) => {
        return { ...base, };
    },
    input: (base) => ({
        ...base,
        padding: '0px'
    }),
    dropdownIndicator: (base) => ({
        ...base,
        height: '29px',
        padding: '6px'
    }),
    clearIndicator: (base) => ({
        ...base,
        height: '29px',
        padding: '6px'
    })
}

class VoteGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectAll: false,
            showDeleteModal: false,
            voteOriginOptions: [],
            chamberOptions: [
                { label: 'House', value: 'H' },
                { label: 'Senate', value: 'S' }
            ],
            saving: false
        };

        this.getVoteTypeReferences = this.getVoteTypeReferences.bind(this);
        this.toggleRow = this.toggleRow.bind(this);
        this.toggleSelectAll = this.toggleSelectAll.bind(this);
        this.saveVotes = this.saveVotes.bind(this);
        this.toggleDeleteVoteModal = this.toggleDeleteVoteModal.bind(this);
        this.deleteVote = this.deleteVote.bind(this);
        this.handleVoiceToggle = this.handleVoiceToggle.bind(this);
    }

    toggleRow(index, vote) {
        let dateList = [...this.props.organizedVotes];
        if (vote !== undefined) {
            dateList[index].Votes.find(x => x.VoteID === vote.VoteID).checked = !dateList[index].Votes.find(x => x.VoteID === vote.VoteID).checked;
        } else {
            dateList[index].checked = !dateList[index].checked;
            dateList[index].Votes.forEach(vote => vote.checked = this.props.showVoice ? dateList[index].checked : !vote.IsVoice ? dateList[index].checked : false);
        }
        this.setState({
            organizedVotes: dateList
        });
    }

    toggleSelectAll() {
        const opposite = !this.state.selectAll;
        let dateList = [...this.props.organizedVotes];
        dateList.forEach(date => {
            date.checked = opposite;
            date.Votes.forEach(vote => {
                vote.checked = opposite
            });
        });
        this.setState({
            selectAll: opposite
        });
    }

    saveVotes(publish, voteToDelete) {
        this.setState({ saving: true }, () => {
            let votesToSave = [];

            if (!voteToDelete) {
                const datesToIterate = [...this.props.organizedVotes].filter(date => date.Votes.find(v => v.checked));
                let checkedVotes = 0;
                let invalidFinalVotePublish = false;
                datesToIterate.some(date => {
                    date.Votes.some(vote => {
                        // Select all votes that are checked and are not already published or not-published
                        if (vote.checked) {
                            checkedVotes++; //we use this when alerting the user if no checked votes were published/unpublished (based on the below logic)
                            if (vote.IsPublic !== publish) {
                                if (this.props.voteOrigin.label === "Committee" && publish && vote.FinalVote && date.Votes.find(v => !v.checked && !v.IsPublic && v.CommitteeID === vote.CommitteeID)) {
                                    this.props.actions.makeToast([{ message: `Before publishing a final committee vote, you must publish all preceding votes from this committee${datesToIterate.length > 1 ? ' (' + moment(date.Date).tz('America/New_York').format("L") + ')' : ''}`, type: "failure", long: true }]);
                                    invalidFinalVotePublish = true; //exit loop if we threw an error toast
                                    return true;
                                }

                                let voteObj = { VoteID: vote.VoteID };

                                if (this.props.chamber.value === "S" && this.props.voteOrigin.value === 1) {
                                    voteObj.VoteLegislation = [vote.LegislationNumber];
                                }

                                if (vote.FinalVote) {
                                    voteObj.LegislationNumber = vote.LegislationNumber;
                                    voteObj.FinalVote = vote.FinalVote;
                                    voteObj.ChamberCode = vote.ChamberCode;
                                    voteObj.CommitteeID = vote.CommitteeID;
                                    voteObj.VoteDate = vote.VoteDate;
                                    voteObj.SessionID = vote.SessionID;
                                    voteObj.CommitteeVotedOnLegislation = date.Votes.filter(v => v.LegislationNumber && (v.IsPublic || v.checked) && v.CommitteeID === vote.CommitteeID).map(v => { return { LegislationNumber: v.LegislationNumber, EventCode: v.EventCode } });
                                }
                                votesToSave.push(voteObj);
                            }
                        }
                    });
                    return invalidFinalVotePublish; //exit loop if we threw an error toast
                });

                if (invalidFinalVotePublish) {
                    this.setState({ saving: false })
                    return;
                }

                if (votesToSave.length > 0) {
                    this.props.actions.saveVoteBulk({ IsPublic: publish, VoteIDs: votesToSave })
                        .then(async () => {
                            // Create a file for all the votes, and create the chairman's report summarized on minutes if FinalVote
                            let chairmansReportFailures = [];
                            if (publish) {
                                for (const vote of votesToSave) {
                                    this.props.actions.voteFileGen('?voteID=' + vote.VoteID)
                                        .then(() => {
                                            if (this.props.votes.voteFileError) {
                                                console.log(this.props.votes.voteFileError.toString());
                                            }
                                        });
                                    if (this.props.voteOrigin.label === "Committee" && vote.FinalVote && vote.CommitteeID && vote.VoteDate) {
                                        const success = await this.props.createChairmansReportSummarizedOnMinutes(vote.SessionID, vote.ChamberCode, vote.CommitteeID, moment(vote.VoteDate).utc().hour(0), vote.CommitteeVotedOnLegislation);
                                        if (!success) { chairmansReportFailures.push(vote.LegislationNumber) }
                                    }
                                };
                            }

                            if (chairmansReportFailures.length) {
                                const chairmansReportVotes = votesToSave.filter(v => v.FinalVote && v.CommitteeID && v.VoteDate);
                                this.props.actions.makeToast([{ message: "Vote Publish Successful, Chairman's Report Save Failed" + (chairmansReportVotes.length > 1 ? " For " + chairmansReportVotes.join(', ') : ''), type: "failure", long: true }]);
                            } else {
                                this.props.actions.makeToast([{ message: "Save Successful", type: "success" }]);
                            }
                            this.props.getVotes();
                            this.setState({ saving: false })
                        }).catch(err => {
                            if (err === 'Aborted') {
                                return;
                            }
                            console.log(err.toString());
                            this.props.actions.makeToast([{ message: "Save Failed", type: "failure" }]);
                            this.setState({ saving: false })
                            this.props.getVotes();
                        });
                } else if (checkedVotes === 0) {
                    this.props.actions.makeToast([{ message: "You have not selected any votes", type: "warning" }]);
                    this.setState({ saving: false })
                } else {
                    this.props.actions.makeToast([{ message: (checkedVotes === 1 ? "This vote has" : "The selected votes have") + (publish ? " already been published" : " not yet been published"), type: "warning", long: true }]);
                    this.setState({ saving: false })
                }
            } else {
                this.setState({
                    deletingVote: true
                }, () => {
                    this.props.actions.getVoteDetails("?voteID=" + this.state.voteToDelete.VoteID, true)
                        .then(() => {
                            votesToSave.push(
                                this.props.votes.voteDetailsResponse[0]
                            )
                            votesToSave[0].DeletionDate = moment();

                            this.props.actions.saveVote({ VoteList: votesToSave })
                                .then(() => {
                                    this.setState({
                                        deletingVote: false,
                                        showDeleteModal: false,
                                        voteToDelete: undefined,
                                        saving: false
                                    }, () => {
                                        this.props.actions.makeToast([{ message: "Vote Deleted", type: "success" }]);
                                        this.props.getVotes();
                                    })
                                }).catch(err => {
                                    if (err === 'Aborted') {
                                        return;
                                    }
                                    console.log(err.toString());
                                    this.props.actions.makeToast([{ message: "Vote Delete Failed", type: "failure" }]);
                                    this.setState({ deletingVote: false, saving: false })
                                    this.props.getVotes();
                                });
                        })
                })
            }
        })
    }

    toggleDeleteVoteModal(voteToDelete) {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            voteToDelete: voteToDelete
        })
    }

    deleteVote() {
        this.saveVotes(false, this.state.voteToDelete)
    }

    async getVoteTypeReferences() {
        await this.props.actions.getVoteTypes()
            .then(() => {
                let voteOriginOptions = [];
                this.props.votes.voteTypes.forEach(type => {
                    type.label = type.Name;
                    type.value = type.VoteTypeID;
                    voteOriginOptions.push(type);
                });
                const voteOrigin = voteOriginOptions.find(o => o.Name === "Floor") ? voteOriginOptions.find(o => o.Name === "Floor") : null;
                this.setState({
                    voteOriginOptions: voteOriginOptions,
                    voteOrigin: voteOrigin
                }, () => {
                    if (voteOrigin) {
                        this.props.getVotes();
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err);
            });
    }

    async getCommittees() {
        await new Promise(res => {
            this.setState({ fetchingCommittees: true }, async () =>
                await this.props.actions.getCommitteeList('includeSubCommittees=true')
                    .then(() => {
                        this.props.committee.committeeList.forEach(cmte => {
                            cmte.label = cmte.Name;
                            cmte.value = cmte.CommitteeID
                        })

                        this.setState({ fetchingCommittees: false, committeeList: this.props.committee.committeeList })
                        res();
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        console.log(err);
                        this.setState({ fetchingCommittees: false })
                    })
            )
        })
    }

    handleChange(key, value) {
        this.props.handleChange(key, value, () => {
            let organizedVotes = [...this.props.organizedVotes];
            organizedVotes.forEach((date, idx) => {
                if (date.show) this.props.showVotes(idx, false)
            });
            this.props.getVotes();
        })
    }

    sortVotes(votes) {
        let organizedVotes = [...this.props.organizedVotes];
        let voteDay = organizedVotes.findIndex(x => moment(x.Date).tz('America/New_York').isSame(moment(votes.original.Date).tz('America/New_York'), "days"));

        if (organizedVotes[voteDay].sortTimeDesc) {
            organizedVotes[voteDay].Votes.sort((a, b) => a.FinalVote === b.FinalVote || this.props.voteOrigin.label === "Floor" ? moment(a.VoteDate).tz('America/New_York').isBefore(moment(b.VoteDate).tz('America/New_York'), "seconds") ? 1 : moment(a.VoteDate).tz('America/New_York').isAfter(moment(b.VoteDate).tz('America/New_York'), "seconds") ? -1 : 0 : a.FinalVote ? 1 : -1)
        } else {
            organizedVotes[voteDay].Votes.sort((a, b) => a.FinalVote === b.FinalVote || this.props.voteOrigin.label === "Floor" ? moment(a.VoteDate).tz('America/New_York').isAfter(moment(b.VoteDate).tz('America/New_York'), "seconds") ? 1 : moment(a.VoteDate).tz('America/New_York').isBefore(moment(b.VoteDate).tz('America/New_York'), "seconds") ? -1 : 0 : a.FinalVote ? 1 : -1)
        }

        organizedVotes[voteDay].sortTimeDesc = !organizedVotes[voteDay].sortTimeDesc;

        this.setState({
            organizedVotes
        })
    }

    handleVoiceToggle() {

    }

    componentDidMount() {
        //set the default chamber to house or senate depending on the user's role
        let disableChamberSelector = false;
        let disableVoteOriginSelector = false;
        let filterVoteOriginSelector = false;
        let selectedChamber = null;

        if (!this.props.login.userClaims.claims.find(x => x.RoleName === "Admin")) {
            //Find if the user is a house vote editor, if so select house, otherwise select senate, and disable the chamber selector
            selectedChamber = this.props.login.userClaims.claims.find(x => x.Resource === "Vote" && x.Scope === "House") ? this.state.chamberOptions.find(chamber => chamber.label === "House") : this.props.login.userClaims.claims.find(x => x.Resource === "Vote" && x.Scope === "Senate") ? this.state.chamberOptions.find(chamber => chamber.label === "Senate") : null;
            disableChamberSelector = true;
            this.handleChange('chamber', selectedChamber);
        }

        if (!this.props.login.userClaims.roles.find(x => x === "SenateCommitteeMgmt")
            && this.props.login.userClaims.roles.find(x => x === "SenateFloorVoteMgmt")
            && !this.props.login.userClaims.roles.find(x => x === "Admin")) {
            disableVoteOriginSelector = true;
        } else if (this.props.login.userClaims.roles.find(x => x === "SenateCommitteeMgmt")
            && !this.props.login.userClaims.roles.find(x => x === "SenateFloorVoteMgmt")
            && !this.props.login.userClaims.roles.find(x => x === "Admin")) {
            filterVoteOriginSelector = true;
        }

        this.setState({
            disableChamberSelector: disableChamberSelector,
            disableVoteOriginSelector: disableVoteOriginSelector,
            filterVoteOriginSelector: filterVoteOriginSelector
        });

        Promise.all([this.getVoteTypeReferences(), this.getCommittees()]).then(() => {
            this.props.getVotes();
        })
    }

    componentWillUnmount() {
        cancelRequest();
    }

    render() {
        const { committeeList, fetchingCommittees, voteOriginOptions, chamberOptions, saving } = this.state;
        const { startDate, endDate, committeeVal, chamber, voteOrigin, isLoaded, organizedVotes, selectedSession, showVoice } = this.props;

        let sessionOptions = [...this.props.sessionOptions];

        let meetingLink;

        if (this.props.organizedVotes && chamber && voteOrigin && chamber.label === "Senate" && voteOrigin.label === "Committee" && this.props.organizedVotes.find(x => x.checked)?.Votes) {
            meetingLink = "/session-details/" + this.props.organizedVotes.find(x => x.checked).Votes[0].SessionCode + "/committee-information/" + this.state.committeeList.find(x => x.CommitteeID === this.props.organizedVotes.find(x => x.checked).Votes[0].CommitteeID).CommitteeNumber + "/meetings/" + (this.props.organizedVotes.find(x => x.checked).Votes.find(y => y.MinutesBookID))
        }

        const VoteActions = (vote) =>
            <div className="vote-information-actions">
                {vote.IsPublic ?
                    <React.Fragment>
                        <Link to={`/vote-management/edit-vote/${vote.VoteID}`} className="icon edit"></Link>
                        <span className="icon green-flag"></span>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <Link to={`/vote-management/edit-vote/${vote.VoteID}`} className="icon edit"></Link>
                        <span className="icon flag"></span>
                    </React.Fragment>
                }
                <span onClick={() => this.toggleDeleteVoteModal(vote)} className="icon delete"></span>
                {vote.FinalVote && <span className="bold">(Final Vote)</span>}
                {vote.IsVoice && <span className="bold">(Voice)</span>}
            </div>

        return (
            <div>
                {this.state.showDeleteModal &&
                    <div className='schedule-modal'>
                        <div className='schedule-modal-content'>
                            <div className='grid-wrapper two'>
                                <div className='inner-grid eight-one-and-one'>
                                    <span>Are you sure you want to delete vote {this.state.voteToDelete.VoteNumber}?</span>
                                    {this.state.deletingVote
                                        ? <div className="small-spinner"></div>
                                        : <button className='button primary' onClick={() => this.deleteVote()}>Yes</button>
                                    }
                                    <button className='button secondary' onClick={() => this.toggleDeleteVoteModal()}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="header-half">
                    <h1>Vote Management</h1>
                </div>

                <div className="toolbar dlas-forms vote-management-filters">
                    <div className="flex-row">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 2fr 70px 18px', gap: '10px' }}>
                            <div>
                                <label className="label" htmlFor="start-date">Session</label>
                                <Select
                                    id="sessionDropdown"
                                    styles={customStyles}
                                    name="session"
                                    options={sessionOptions.reverse()}
                                    onChange={value => this.handleChange('selectedSession', value)}
                                    value={selectedSession}
                                    style={{ width: "150px" }}
                                    classNamePrefix='no-width-dropdown-input'
                                    getOptionLabel={o => o.SessionYear + " " + o.DisplayName}
                                    getOptionValue={o => o.SessionCode}
                                />
                            </div>
                            <div>
                                <label className="label" htmlFor="start-date">Date/Start Date</label>
                                <DatePicker
                                    name="start-date"
                                    selected={startDate}
                                    onChange={value => this.props.handleDateChange('startDate', moment(value).tz('America/New_York'), () => {
                                        let organizedVotes = [...this.props.organizedVotes];
                                        organizedVotes.forEach((date, idx) => {
                                            if (date.show) this.props.showVotes(idx, false)
                                        });
                                        this.props.getVotes();
                                    })}
                                />
                            </div>
                            <div>
                                <label className="label" htmlFor="end-date">End Date</label>
                                <DatePicker
                                    name="end-date"
                                    selected={endDate}
                                    onChange={value => this.props.handleDateChange('endDate', value ? moment(value).tz('America/New_York') : null, () => {
                                        let organizedVotes = [...this.props.organizedVotes];
                                        organizedVotes.forEach((date, idx) => {
                                            if (date.show) this.props.showVotes(idx, false)
                                        });
                                        this.props.getVotes();
                                    })}
                                    isClearable
                                />
                            </div>
                            <div>
                                <label className="label" htmlFor="chamber">Chamber</label>
                                <Select
                                    styles={customStyles}
                                    name="chamber"
                                    options={chamberOptions}
                                    isDisabled={this.state.disableChamberSelector}
                                    onChange={value => this.handleChange('chamber', value)}
                                    value={chamber}
                                    style={{ width: "150px" }}
                                    classNamePrefix='no-width-dropdown-input'
                                />
                            </div>
                            <div>
                                <label className="label" htmlFor="committee">Vote Origin</label>
                                <Select
                                    styles={customStyles}
                                    name="vote-origin"
                                    options={!this.state.filterVoteOriginSelector ? voteOriginOptions : [...voteOriginOptions.filter(x => x.value != 3)]}
                                    isDisabled={this.state.disableVoteOriginSelector}
                                    onChange={value => this.handleChange('voteOrigin', value)}
                                    value={voteOrigin}
                                    style={{ width: "150px" }}
                                    classNamePrefix='no-width-dropdown-input'
                                />
                            </div>
                            <div>
                                {voteOrigin && voteOrigin.label !== "Floor" &&
                                    <React.Fragment>
                                        <label className="label" htmlFor="committee">Committee</label>
                                        <Select
                                            styles={customStyles}
                                            name="committee"
                                            options={committeeList && chamber ? committeeList.filter(c => c.ChamberCode === chamber.value && (voteOrigin.label === "Committee" ? !c.ParentCommitteeID : c.ParentCommitteeID)) : []}
                                            onChange={value => this.handleChange('committee', value)}
                                            value={committeeVal}
                                            isDisabled={!chamber}
                                            placeholder={fetchingCommittees ? 'Getting Committees....' : 'Select...'}
                                            style={{ width: "350px" }}
                                            isClearable
                                            classNamePrefix='no-width-dropdown-input'
                                        />
                                    </React.Fragment>}
                            </div>
                            <div>
                                {voteOrigin && voteOrigin.label === "Floor" && chamber.label === "Senate" &&
                                    <div className="is-filter-wrapper" style={{ display: "grid", gridTemplateRows: "1fr 1fr" }}>
                                        <label>Show Voice</label>
                                        <div className="toggle-switch" onClick={() => this.handleChange("showVoice", !showVoice)} style={{ marginTop: "3px" }}>
                                            <input id="se-voice-toggle" checked={showVoice} type="checkbox" style={{ width: "auto" }} />
                                            <span className="slider"></span>
                                        </div>
                                    </div>
                                }
                            </div>
                            <button className="icon refresh" onClick={() => this.props.getVotes()} style={{ height: "28px", marginTop: "25px" }} disabled={!this.props.organizedVotes || this.props.organizedVotes.length === 0} />
                        </div>
                    </div>
                </div>
                <br />
                <div className="toolbar minutes-toolbar vote-toolbar dlas-forms">
                    <button type="button" disabled={saving || (voteOrigin && voteOrigin.label !== "Floor" && (!committeeVal || !committeeVal.label))} onClick={() => this.saveVotes(true)} className="button">Publish</button>
                    <button type="button" disabled={saving || (voteOrigin && voteOrigin.label !== "Floor" && (!committeeVal || !committeeVal.label))} onClick={() => this.saveVotes(false)} className="button danger">Unpublish</button>
                    {(chamber && voteOrigin && chamber.label === "Senate" && voteOrigin.label === "Committee")
                        ? <>
                            <button type="button" className="button primary" disabled={saving || (this.props.organizedVotes && this.props.organizedVotes.filter(x => x.checked).length != 1 || !this.props.committeeVal)} onClick={() => this.props.history.push("/session-details/" + this.props.organizedVotes.find(x => x.checked)?.Votes[0].SessionCode + "/committee-information/" + this.state.committeeList.find(x => x.CommitteeID === this.props.organizedVotes.find(x => x.checked)?.Votes[0].CommitteeID).CommitteeNumber + "/meetings/" + (this.props.organizedVotes.find(x => x.checked).Votes[0]?.MinutesBookID ?? this.props.organizedVotes.find(x => x.checked).Votes[this.props.organizedVotes.find(x => x.checked)?.Votes.length - 1 ?? 0].MinutesBookID) + "/2")}>Chair's Report</button>
                            <button type="button" className="button primary" disabled={saving || (this.props.organizedVotes && this.props.organizedVotes.filter(x => x.checked).length != 1 || !this.props.committeeVal)} onClick={() => this.props.history.push("/session-details/" + this.props.organizedVotes.find(x => x.checked)?.Votes[0].SessionCode + "/committee-information/" + this.state.committeeList.find(x => x.CommitteeID === this.props.organizedVotes.find(x => x.checked)?.Votes[0].CommitteeID).CommitteeNumber + "/meetings/" + (this.props.organizedVotes.find(x => x.checked).Votes[0]?.MinutesBookID ?? this.props.organizedVotes.find(x => x.checked).Votes[this.props.organizedVotes.find(x => x.checked)?.Votes.length - 1 ?? 0].MinutesBookID) + "/3")}>Vote Sheet</button>
                            <button type="button" className="button primary" disabled={!committeeVal} onClick={() => this.props.history.push("/vote-management/create-vote/" + committeeVal.CommitteeNumber)}>Create Vote</button>
                        </>
                        : (chamber && voteOrigin && chamber.label === "House" && voteOrigin.label === "Committee")
                            ? <>
                                <div />
                                <div />
                                <button type="button" className="button primary" disabled={!committeeVal} onClick={() => this.props.history.push("/vote-management/create-vote/" + committeeVal.CommitteeNumber)}>Create Vote</button>
                            </>
                            : null
                    }
                    <div />
                </div>
                <ReactTable
                    resizable={false}
                    loading={!isLoaded}
                    data={organizedVotes}
                    noDataText="No votes found"
                    ref={r => this.reactTable = r}
                    columns={[
                        {
                            sortable: false,
                            filterable: false,
                            style: { textAlign: 'center' },
                            width: 45,
                            Header: x => {
                                return (
                                    <input
                                        id={'cm-checkbox-selectall'}
                                        type="checkbox"
                                        className="checkbox"
                                        checked={this.state.selectAll}
                                        onChange={this.toggleSelectAll}
                                    />
                                );
                            },
                            Cell: ({ original, index }) => {
                                return (
                                    <input
                                        id={'cm-checkbox-' + index}
                                        type="checkbox"
                                        className="checkbox"
                                        checked={original.checked}
                                        onChange={() => this.toggleRow(index)}
                                    />
                                );
                            }
                        },
                        {
                            Header: "",
                            accessor: "Date",
                            Cell: row => {
                                if (row.original.show) {
                                    return (
                                        <div className="vote-date-container">
                                            <div className="vote-date" onClick={() => this.props.showVotes(row.index)}>
                                                <span>{moment(row.value).tz('America/New_York').format('L')}</span>
                                                <button className="arrow-up">votes</button>
                                            </div>
                                            <div className={(chamber.value === "S" ? `senate-vote` : `house-vote`) + ` vote-information${voteOrigin.label === "Floor" ? "" : " committee"}`}>
                                                {voteOrigin.label === "Floor" ?
                                                    <React.Fragment>
                                                        <span className="vote-information-header"></span>
                                                        <span className="vote-information-header">Legislation</span>
                                                        <span className="vote-information-header">Action</span>
                                                        <span className="vote-information-header">Vote Number</span>
                                                        <span className="vote-information-header">Vote Tally</span>
                                                        <span className="vote-information-header" onClick={() => this.sortVotes(row)} style={{ cursor: "pointer" }}>Vote Time</span>
                                                        <span className="vote-information-header"></span>
                                                        {row.original.Votes.filter(x => showVoice || (!showVoice && !x.IsVoice)).map((vote, voteIndex) =>
                                                            <React.Fragment key={voteIndex}>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}><input type="checkbox" checked={vote.checked} onChange={() => this.toggleRow(row.index, vote)} /></span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{!["block", "cancelled"].includes(vote.LegislationNumber?.toLowerCase()) ? <Link to={`/bill-details/${vote.SessionCode}/${vote.LegislationNumber}`} target="_blank" rel="noreferrer">{vote.LegislationNumber}</Link> : <span >{vote.LegislationNumber}</span>}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{vote.VoteActionDescription}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{vote.VoteNumber}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{vote.VoteTally}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{moment(vote.VoteDate).tz('America/New_York').format("LTS")}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{VoteActions(vote)}</span>
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <span className="vote-information-header checkbox-container"></span>
                                                        <span className="vote-information-header">Legislation</span>
                                                        <span className="vote-information-header">Action</span>
                                                        <span className="vote-information-header">Committee</span>
                                                        {chamber.value === "S" && <span className="vote-information-header" style={{ paddingLeft: "5px" }}>Referrer Committee</span>}
                                                        <span className="vote-information-header">Vote Tally</span>
                                                        <span className="vote-information-header"></span>
                                                        {row.original.Votes.sort((a, b) => { return (a.LegislationNumber && b.LegislationNumber) ? a.LegislationNumber.localeCompare(b.LegislationNumber, 'en', { numeric: true }) : 0 }).map((vote, voteIndex) =>
                                                            <React.Fragment key={voteIndex}>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"} title={"Vote Number: " + vote.VoteNumber}><input type="checkbox" checked={vote.checked} onChange={() => this.toggleRow(row.index, vote)} /></span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{vote.LegislationNumber?.toLowerCase() !== "block" ? <Link to={`/bill-details/${vote.SessionCode}/${vote.LegislationNumber}`} target="_blank" rel="noreferrer">{vote.LegislationNumber}</Link> : <span>{vote.LegislationNumber}</span>}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"} title={"Vote Number: " + vote.VoteNumber}>{this.props.voteActions && this.props.voteActions.find(x => x.EventCode === vote.EventCode) ? this.props.voteActions.find(x => x.EventCode === vote.EventCode).Description : vote.EventCode}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"} title={vote.CommitteeName}>{vote.CommitteeName}</span>
                                                                {chamber.value === "S" && <span className={voteIndex % 2 > 0 ? "even" : "odd"} title={vote.ReferToCommitteeID} style={{ paddingLeft: "5px" }}>{vote.ReferToCommitteeName}</span>}
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"} title={"Vote Number: " + vote.VoteNumber}>{vote.VoteTally}</span>
                                                                <span className={voteIndex % 2 > 0 ? "even" : "odd"}>{VoteActions(vote)}</span>
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div style={{ cursor: 'pointer' }} onClick={() => this.props.showVotes(row.index)}>
                                            <span>{moment(row.value).tz('America/New_York').format('L')}</span>
                                            <button style={{ float: 'right' }} className="arrow-down">votes</button>
                                        </div>
                                    );
                                }
                            }
                        }
                    ]}
                    defaultPageSize={15}
                    pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
                    className="committee-table -striped -highlight"
                />
            </div>)

    }
}

export default connect(
    (state) => {
        const { votes, nav, committee, login } = state;
        return {
            votes,
            nav,
            committee,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, voteActionCreators, navActionCreators, committeeActionCreators, authActionCreators), dispatch)
        }
    }
)(VoteGrid)
